import { Component, OnInit } from '@angular/core';
import { LoggingService } from '../services/index';
import { AuthService } from '../shared';
@Component({
    template: '<h2 class="text-center mt-md-5">Ingen adgang</h2><h4 class="text-center mt-3 text-danger">Beklager men du har ingen roller, som giver dig adgang til Grundrisk</h4>'
})
export class PageAccessDeniedComponent implements OnInit {
    constructor(
        private readonly authService: AuthService,
        private readonly loggingService: LoggingService) {
    }

    public ngOnInit(): void {
        const userId = this.authService.getUserPrincipalName();
        const regionCode = this.authService.getRegionCode();
        this.loggingService.LogEventLoginAsFailed(userId, regionCode, 'Access denied');
    }
}
